'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'virus-covid';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e4a8';
var svgPathData = 'M216 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l24 0 0 32.7c-41 3.4-78.3 19.6-108 44.7l-23.1-23.1 0 0 17-17c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L46.7 103.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l17-17 0 0 23.1 23.1C84.3 161.7 68 199 64.7 240l-32.7 0 0-24c0-8.8-7.2-16-16-16S0 207.2 0 216l0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-24 32.7 0c3.4 41 19.6 78.3 44.7 108l-23.1 23.1 0 0-17-17c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l56.6 56.6c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-17-17 0 0 23.1-23.1c29.6 25.1 67 41.4 108 44.7l0 32.7-24 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-24 0 0-32.7c41-3.4 78.3-19.6 108-44.7l23.1 23.1-17 17c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l56.6-56.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-17 17-23.1-23.1c25.1-29.6 41.4-67 44.7-108l32.7 0 0 24c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 24-32.7 0c-3.4-41-19.6-78.3-44.7-108l23.1-23.1 0 0 17 17c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L408.7 46.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l17 17 0 0-23.1 23.1C350.3 84.3 313 68 272 64.7l0-32.7 24 0c8.8 0 16-7.2 16-16S304.8 0 296 0L216 0zm40 96a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm88 192a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM192 248a24 24 0 1 0 0-48 24 24 0 1 0 0 48z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faVirusCovid = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;